import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import Home from "./pages/Home"
import AboutUs from "./components/AboutUs";
import CoursesSection from "./components/CoursesSection";
import ContactPage from "./components/ContactPage";
import Training from "./components/Training";
import Business from "./components/Business";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/AboutUs" element={<AboutUs />} />
        <Route path="/CoursesSection" element={<CoursesSection />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/training" element={<Training />} />
        <Route path="/business" element={<Business />} />
      </Routes>
    </Router>
  );
}

export default App;
